import React from "react";
import '../../scss/mainPage.scss';
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TheHeader from "./comm/TheHeader";
import Swal from 'sweetalert';
import ApiHelper from "src/utils/api/api_helper";
import {
  CButton,
  CContainer,
  CCol,
  CRow,
  CCardBody,
  CCardHeader,
  CCardFooter,
} from "@coreui/react";
import { AgreeIcon } from 'src/assets/index';
import { useHistory } from "react-router-dom";
import { persistor } from "src/store";

const MainPage = (props) => {
  const { main } = useSelector((state) => state);
  const dispatch = useDispatch();
  const history = useHistory();
  const ifKey = useLocation().pathname.substring(1);
  const appUrl = `${process.env.REACT_APP_API_HOST}`;
  const corpNm = useLocation().pathname.split('/')[1];

  // 뒤로가기 막기
  React.useEffect(() => {
    window.history.pushState({}, null, '#init');
    window.history.pushState({}, null, props.location.pathname);
    window.onpopstate = function(e) {
      if( window.location.hash == "#init") {
        window.history.go(1);
      }
    }
  }, []);

  const handleGoBackMain = () => {
    persistor.purge();
    history.push(`/${corpNm}`);
  };

  return (
    <>
      <div className="c-main">
        <CContainer>
        <img src={AgreeIcon} className="icon" style={{marginTop: "25%"}}/>
          <h1 style={{marginTop: "5%"}}>
            <b>제출완료</b>
          </h1>
        </CContainer>
      </div>
      <footer className="mainFooter layout-footer">
        <button className="btn-footer" type="button" onClick={handleGoBackMain}>확인</button>
      </footer>
    </>
  );
};

export default MainPage;
